import BrandForm from "components/forms/BrandForm"
import { useCurrentId } from "hooks/useCurrentId"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { getTintVTOService } from "services/tintvto"
import { BaseHeaderLayout, Box, ContentLayout, Link } from "@strapi/design-system"
import { ArrowLeft } from "@strapi/icons"
import { useAlert } from "providers/AlertProvider"
import { Brand } from "types"
import { useSaveBrandMutation } from "hooks/query/useBrandsQuery"

interface BrandEditPageProps {
  add?: boolean
}

export const BrandPage = ({ add }: BrandEditPageProps) => {
  const { t } = useTranslation()
  const { showAlert: _showAlert } = useAlert()
  const navigate = useNavigate()
  const brandId = useCurrentId()
  const service = getTintVTOService()
  const [brand, setBrand] = useState<Brand>({
    id: brandId,
    slug: "",
    name: "",
    sub: "",
  })

  useEffect(() => {
    ;(async () => {
      if (!add && brandId) {
        const { data } = await service.brandById(brandId, "")
        setBrand({
          ...data.brand,
        })
      } else {
        setBrand({
          id: "",
          name: "",
          slug: "",
          sub: "",
        })
      }
    })()
  }, [brandId, add])
  const { isPending, mutate: saveBrandMutation } = useSaveBrandMutation()

  return (
    <Box>
      <BaseHeaderLayout
        title={add ? t("brandPage.addTitle") : t("brandPage.editTitle")}
        as={"h1"}
        navigationAction={
          <Link startIcon={<ArrowLeft />} to={`/brands`}>
            {t("brandPage.backToBrands")}
          </Link>
        }
      />
      <ContentLayout>
        <BrandForm
          brand={brand}
          setBrand={setBrand}
          handleSave={() =>
            saveBrandMutation(brand, {
              onSuccess: () => {
                navigate(`/brands`)
              },
            })
          }
          loading={isPending}
        />
      </ContentLayout>
    </Box>
  )
}
